var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsorted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1303 9.26995C11.2151 9.35477 11.2575 9.45522 11.2575 9.57129C11.2575 9.68736 11.2151 9.78781 11.1303 9.87263L8.1303 12.8726C8.04548 12.9574 7.94503 12.9999 7.82896 12.9999C7.71289 12.9999 7.61244 12.9574 7.52762 12.8726L4.52762 9.87263C4.4428 9.78781 4.40039 9.68736 4.40039 9.57129C4.40039 9.45522 4.4428 9.35477 4.52762 9.26995C4.61244 9.18513 4.71289 9.14272 4.82896 9.14272H10.829C10.945 9.14272 11.0455 9.18513 11.1303 9.26995ZM11.1303 6.69852C11.2151 6.78334 11.2575 6.88379 11.2575 6.99986C11.2575 7.11593 11.2151 7.21638 11.1303 7.3012C11.0455 7.38602 10.945 7.42843 10.829 7.42843H4.82896C4.71289 7.42843 4.61244 7.38602 4.52762 7.3012C4.4428 7.21638 4.40039 7.11593 4.40039 6.99986C4.40039 6.88379 4.4428 6.78334 4.52762 6.69852L7.52762 3.69852C7.61244 3.6137 7.71289 3.57129 7.82896 3.57129C7.94503 3.57129 8.04548 3.6137 8.1303 3.69852L11.1303 6.69852Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsorted);
export default __webpack_public_path__ + "static/media/unsorted.3b692fb51e3e8f6857d4a6aff0c747d3.svg";
export { ForwardRef as ReactComponent };